(function() { window.GUID_66445239_f77b_4d11_836d_8a07877e1ad2 = { getGuid: function() { return "66445239-f77b-4d11-836d-8a07877e1ad2"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class NotificationsModal extends Controls.ControlBase {
            constructor() {
                super(...arguments);
                this.unfollowButtonId = "button-cs-notifications-modal-unsubscribe";
                this.followButtonId = "button-cs-notifications-modal-subscribe";
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                try {
                    this.Log("Instantiating control...");
                    this.Log("Params:", params);
                    this.controlId = params[0];
                    this.friendPersonaId = params[1];
                    this.highlightedNotification = params[2];
                }
                catch (error) {
                    console.error("Error instantiating control.", error);
                }
            }
            OnBindEvents() {
                try {
                    this.Log("Binding events...");
                    this.bindUnfollowButtonClick();
                    this.bindFollowButtonClick();
                    const accordionSelector = ".accordion-friendnotifications";
                    this.$accordion = this.$Control.find(accordionSelector);
                    if (!this.$accordion.length) {
                        this.Log(`No accordion found using selector: "${accordionSelector}". Aborting.`);
                        return;
                    }
                    this.accordion = Controls.GetInstance(Controls.Accordion, this.$accordion, true);
                    if (!this.accordion) {
                        this.Log(`No accordion instance found using selector: "${accordionSelector}". Aborting.`);
                        return;
                    }
                    this.bindAccordionHeaderClick();
                    this.bindCheckboxClick();
                }
                catch (error) {
                    console.error("Error binding events.", error);
                }
            }
            OnDispose() { }
            OnControlRendered() { }
            bindUnfollowButtonClick() {
                CS.DOM.$body.offon("click.unfollow-button-clickedddd", `#${this.unfollowButtonId}`, this.unfollowPersona.bind(this));
            }
            bindFollowButtonClick() {
                CS.DOM.$body.offon("click.follow-button-clickedddd", `#${this.followButtonId}`, this.followPersona.bind(this));
            }
            unfollowPersona() {
                try {
                    this.Log("Unfollowing persona...");
                    const url = CS.Url.CSUrl("FriendUpdateFollow");
                    if (CS.Helper.isNullOrWhiteSpace(url)) {
                        Controls.ScriptErrorLogger.DisplayError({
                            message: "Url is null or whitespace.",
                            file: "NotificationsModal.ts",
                        });
                        throw new Error("Url is null or whitespace.");
                    }
                    const data = {
                        friendPersonaId: this.friendPersonaId,
                        wasFriend: true,
                    };
                    CS.Ajax.Post(url, data, (response) => {
                        this.Log("Unfollowed persona.");
                        this.accordion.RefreshContent();
                        this.updateFollowUnfollowButtonsVisibility({ isFolloWing: false });
                        this.Trigger(NotificationsModal.EventNames.UnfollowedPersona);
                    });
                }
                catch (error) {
                    console.error("Error while unfollowing persona.", error);
                }
            }
            followPersona() {
                try {
                    this.Log("Following persona...");
                    const url = CS.Url.CSUrl("FriendUpdateFollow");
                    if (CS.Helper.isNullOrWhiteSpace(url)) {
                        Controls.ScriptErrorLogger.DisplayError({
                            message: "Url is null or whitespace.",
                            file: "NotificationsModal.ts",
                        });
                        throw new Error("Url is null or whitespace.");
                    }
                    const data = {
                        friendPersonaId: this.friendPersonaId,
                        wasFriend: false,
                    };
                    CS.Ajax.Post(url, data, (response) => {
                        this.Log("Followed persona.");
                        this.accordion.RefreshContent();
                        this.updateFollowUnfollowButtonsVisibility({ isFolloWing: true });
                        this.Trigger(NotificationsModal.EventNames.FollowedPersona);
                    });
                }
                catch (error) {
                    console.error("Error while following persona.", error);
                }
            }
            updateFollowUnfollowButtonsVisibility(params) {
                if (params.isFolloWing) {
                    $(`#${this.unfollowButtonId}`).removeClass("hiddenforced");
                    $(`#${this.followButtonId}`).addClass("hiddenforced");
                }
                else {
                    $(`#${this.unfollowButtonId}`).addClass("hiddenforced");
                    $(`#${this.followButtonId}`).removeClass("hiddenforced");
                }
            }
            unsubscribeFromPersona() {
                try {
                    this.Log("Unsubscribing from persona...");
                    CS.Ajax.Post(CS.Url.CSUrl("friendsubscribetofriend"), { isSubscribed: false }, (response) => {
                        this.Log("Unsubscribed from persona.");
                        this.accordion.RefreshContent();
                        this.Trigger(NotificationsModal.EventNames.UnsubscribedFromPersona);
                    });
                }
                catch (error) {
                    console.error("Error unsubscribing from persona.", error);
                }
            }
            subscribeToPersona() {
                try {
                    this.Log("Subscribing to persona...");
                    CS.Ajax.Post(CS.Url.CSUrl("friendsubscribetofriend"), { isSubscribed: true }, (response) => {
                        this.Log("Subscribed to persona.");
                        this.accordion.RefreshContent();
                        this.updateFollowUnfollowButtonsVisibility({ isFolloWing: true });
                        this.Trigger(NotificationsModal.EventNames.SubscribedToPersona);
                    });
                }
                catch (error) {
                    console.error("Error subscribing to persona.", error);
                }
            }
            updateNotification(e) {
                try {
                    this.Log("Updating notification...");
                    const notificationData = e.data
                        .extraData, isSubscribed = e.data.value == "true", data = {
                        isSubscribed,
                        notificationSubscriptionId: notificationData.Id,
                        notificationType: notificationData.NotificationType,
                    };
                    CS.Ajax.Post(CS.Url.CSUrl("friendupdatefriendsubscription"), data, (response) => {
                        this.Log("Notification updated.");
                    });
                }
                catch (error) {
                    console.error("Error updating notification.", error);
                }
            }
            bindAccordionHeaderClick() {
                try {
                    this.Log("Binding accordion header click...");
                    const $accordionHeader = this.$accordion.find(".accordion-header");
                    if ($accordionHeader.length > 0) {
                        const $firstChild = $accordionHeader.children().first();
                        $firstChild.css("cursor", "pointer");
                        $accordionHeader.offon("click.accordion-friendnotifications-headerclicked", (e) => {
                            this.Log("Handling click on accordion header...");
                            const $target = $(e.target);
                            const isCheckboxChild = $target.closest(".checkbox.control-cs").length > 0;
                            if (isCheckboxChild) {
                                this.Log("Click was on checkbox, aborting.");
                                return;
                            }
                            const $checkbox = $firstChild.find(".checkbox.control-cs");
                            if ($checkbox.length > 0) {
                                this.Log("Click was not on checkbox, triggering checkbox click...");
                                $checkbox.trigger("click");
                            }
                        });
                        this.Log("Accordion header click bound.");
                    }
                }
                catch (error) {
                    console.error("Error binding accordion header click.", error);
                }
            }
            bindCheckboxClick() {
                try {
                    this.Log("Binding checkbox click...");
                    CS.Controls.CheckBox.Events.CheckboxValueChanged({
                        selector: "#" + this.accordion.ControlId,
                        childSelector: ".checkbox",
                        callback: (checkBox, e) => {
                            e.jqueryEventObject.stopImmediatePropagation();
                            this.handleNotifCheckboxClick({
                                e,
                                checkbox: checkBox,
                                type: checkBox.$Control.hasClass("notif-checkbox-global")
                                    ? "global"
                                    : "notification",
                            });
                        },
                    });
                    this.Log("Checkbox click bound.");
                }
                catch (error) {
                    console.error("Error binding checkbox click.", error);
                }
            }
            handleNotifCheckboxClick({ e, checkbox, type, }) {
                try {
                    this.Log("Handling checkbox click...");
                    if (type == "global") {
                        this.Log("Handling global notification checkbox click...");
                        const isSubscribed = e.data.value == "true";
                        if (isSubscribed) {
                            this.subscribeToPersona();
                        }
                        else {
                            this.unsubscribeFromPersona();
                        }
                    }
                    else {
                        this.Log("Handling notification checkbox click...");
                        this.updateNotification(e);
                    }
                }
                catch (error) {
                    console.error("Error handling checkbox click.", error);
                }
            }
        }
        Controls.NotificationsModal = NotificationsModal;
        (function (NotificationsModal) {
            class Events {
                static UnfollowedPersona(param) {
                    Controls.RegisterEvent(NotificationsModal, EventNames.UnfollowedPersona, param);
                }
                static FollowedPersona(param) {
                    Controls.RegisterEvent(NotificationsModal, EventNames.FollowedPersona, param);
                }
                static SubscribedToPersona(param) {
                    Controls.RegisterEvent(NotificationsModal, EventNames.SubscribedToPersona, param);
                }
                static UnsubscribedFromPersona(param) {
                    Controls.RegisterEvent(NotificationsModal, EventNames.UnsubscribedFromPersona, param);
                }
            }
            NotificationsModal.Events = Events;
            class EventNames {
            }
            EventNames.UnfollowedPersona = "UnfollowedPersona";
            EventNames.FollowedPersona = "FollowedPersona";
            EventNames.SubscribedToPersona = "SubscribedToPersona";
            EventNames.UnsubscribedFromPersona = "UnsubscribedFromPersona";
            NotificationsModal.EventNames = EventNames;
        })(NotificationsModal = Controls.NotificationsModal || (Controls.NotificationsModal = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=NotificationsModal.js.map
